import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Remove SEO prerender placeholder before React mounts
const seoPlaceholder = document.getElementById("seo-prerender");
if (seoPlaceholder) seoPlaceholder.remove();

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
